'use client';

import {
  ArrowDownWideNarrow,
  ArrowUpWideNarrow,
  MessageSquare,
  X,
} from 'lucide-react';
import { useTranslations } from 'next-intl';

import type { SortOrder } from './types';

interface SidebarHeaderProps {
  openCommentCount: number;
  sortOrder: SortOrder;
  showSortToggle: boolean;
  onToggleSort: () => void;
  onClose: () => void;
}

export function SidebarHeader({
  openCommentCount,
  sortOrder,
  showSortToggle,
  onToggleSort,
  onClose,
}: SidebarHeaderProps) {
  const t = useTranslations();
  const SortIcon =
    sortOrder === 'newest' ? ArrowDownWideNarrow : ArrowUpWideNarrow;
  const sortLabel =
    sortOrder === 'newest'
      ? t('get-feedback-sidebar-sortNewest')
      : t('get-feedback-sidebar-sortOldest');

  return (
    <div className="flex items-center gap-2 border-b border-border px-4 py-3">
      <MessageSquare className="h-4 w-4 text-muted-foreground" />
      <h2 className="flex-1 text-sm font-semibold text-foreground">
        {openCommentCount > 0
          ? t('get-feedback-sidebar-commentsHeading', {
              count: openCommentCount,
            })
          : t('get-feedback-toolbar-comments')}
      </h2>
      {showSortToggle && (
        <button
          onClick={onToggleSort}
          aria-label={sortLabel}
          title={sortLabel}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <SortIcon className="h-4 w-4" />
        </button>
      )}
      <button
        onClick={onClose}
        aria-label={t('get-feedback-sidebar-closePanel')}
        className="text-muted-foreground hover:text-foreground transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
